export const textListOptionMenu = {
  minLevel: 3,
  maxLevel: 9,
  menuDisplayMaxLevel: 3
};

export const mode = {
  default: 'd',
  custom: 'c'
};

export const orderedList = {
  defaultLevelStyle: {
    'numbering-style': 0,
    'numbering-regex': ''
  },
  stylesMapping: {
    1: 'numbers',
    2: 'numbers-with-two-digits',
    3: 'numbers-with-three-digits',
    4: 'numbers-with-four-digits',
    5: 'letters',
    6: 'capital-letters',
    7: 'roman-numbers-lower',
    8: 'roman-numbers'
  },
  markMapping: {
    '.': '^#.',
    ')': '^#)',
    '-': '^#-'
  }
};

export const bulletList = {
  defaultCharacterStyle: {
    charCode: 'U+2022'
  }
};

export const orderedListOptionMenuOptions = [
  {
    value: 'numbers',
    label: '1, 2, 3, 4'
  },
  {
    value: 'numbers-with-two-digits',
    label: '01, 02, 03, 04'
  },
  {
    value: 'numbers-with-three-digits',
    label: '001, 002, 003, 004'
  },
  {
    value: 'numbers-with-four-digits',
    label: '0001, 0002, 0003, 0004'
  },
  {
    value: 'letters',
    label: 'a, b, c, d'
  },
  {
    value: 'capital-letters',
    label: 'A, B, C, D'
  },
  {
    value: 'roman-numbers-lower',
    label: 'i, ii, iii, iv'
  },
  {
    value: 'roman-numbers',
    label: 'I, II, III, IV'
  }
];

export const bulletListOptionMenuOptions = [
  {
    value: 'U+2022',
    label: '•'
  },
  {
    value: 'U+25E6',
    label: '◦'
  },
  {
    value: 'U+2010',
    label: '‐'
  },
  {
    value: 'U+25B8',
    label: '▸'
  },
  {
    value: 'U+FFED',
    label: '￭'
  }
];

export const customSymbols = [
  'U+0024', 'U+002B', 'U+003C', 'U+003D', 'U+003E', 'U+005E', 'U+0060', 'U+007C', 'U+007E', 'U+00A2',
  'U+00A3', 'U+00A4', 'U+00A5', 'U+00A6', 'U+0308', 'U+00A9', 'U+00AC', 'U+00AE', 'U+0304', 'U+00B0',
  'U+00B1', 'U+0301', 'U+0327', 'U+00D7', 'U+00F7', 'U+0306', 'U+0307', 'U+030A', 'U+0328', 'U+0303',
  'U+030B', 'U+02DE', 'U+0375', 'U+0341', 'U+0344', 'U+1FBD', 'U+1FBF', 'U+1FC0', 'U+1FC1', 'U+1FCD',
  'U+1FCE', 'U+1FCF', 'U+1FDD', 'U+1FDE', 'U+1FDF', 'U+1FED', 'U+1FEE', 'U+1FEF', 'U+1FFD', 'U+1FFE',
  'U+00BD', 'U+20A1', 'U+20A3', 'U+20A4', 'U+20A6', 'U+20A7', 'U+20A9', 'U+20AB', 'U+20AC', 'U+20AE',
  'U+20B1', 'U+20B2', 'U+20B4', 'U+20B5', 'U+20B8', 'U+20B9', 'U+20BA', 'U+20BD', 'U+2105', 'U+2116',
  'U+2117', 'U+2120', 'U+2122', 'U+212E', 'U+2190', 'U+2191', 'U+2192', 'U+2193', 'U+2194', 'U+2195',
  'U+2196', 'U+2197', 'U+2198', 'U+2199', 'U+21A8', 'U+21D0', 'U+21D1', 'U+21D2', 'U+21D3', 'U+2200',
  'U+2202', 'U+2203', 'U+2206', 'U+220F', 'U+2211', 'U+2212', 'U+2215', 'U+2219', 'U+221A', 'U+221E',
  'U+2220', 'U+2229', 'U+222B', 'U+2237', 'U+2245', 'U+2260', 'U+2261', 'U+2264', 'U+2265', 'U+2310',
  'U+231C', 'U+231D', 'U+231E', 'U+231F', 'U+2324', 'U+2325', 'U+2326', 'U+2327', 'U+2328', 'U+2329',
  'U+232A', 'U+2336', 'U+2395', 'U+23B4', 'U+23B5', 'U+23D0', 'U+2500', 'U+2501', 'U+2502', 'U+2503',
  'U+2504', 'U+2505', 'U+2506', 'U+2507', 'U+2508', 'U+2509', 'U+250A', 'U+250B', 'U+250C', 'U+250D',
  'U+250E', 'U+250F', 'U+2510', 'U+2511', 'U+2512', 'U+2513', 'U+2514', 'U+2515', 'U+2516', 'U+2517',
  'U+2518', 'U+2519', 'U+25C9', 'U+25CA', 'U+25CB', 'U+25CC', 'U+25CF', 'U+25D8', 'U+25D9', 'U+25E6',
  'U+2610', 'U+2611', 'U+2615', 'U+263A', 'U+263B', 'U+263C', 'U+2640', 'U+2642', 'U+2660', 'U+2663',
  'U+2665', 'U+2666', 'U+266A', 'U+266B', 'U+2713', 'U+2712', 'U+2717', 'U+2762', 'U+2764', 'U+1F3B5',
  'U+1F3B6'
];

export const regexOptions = [
  {
    value: '^#',
    label: 'Number',
    key: 'number'
  },
  {
    value: '^p',
    label: 'Paragraph Symbol',
    key: 'paragraph_symbol'
  },
  {
    value: '^J',
    label: 'Section Symbol',
    key: 'section_symbol'
  },
  {
    value: '^B',
    label: 'Bullet Character',
    key: 'bullet_character'
  },
  {
    value: '^e',
    label: 'Ellipsis',
    key: 'ellipsis'
  }
];
